export const REQUEST_ADJUSTER_INVOICES = 'dashboard/REQUEST_ADJUSTER_INVOICES'; 
export const RECEIVE_ADJUSTER_INVOICES = 'dashboard/RECEIVE_ADJUSTER_INVOICES'; 
export const RECEIVE_ADJUSTER_INVOICES_FAILURE = 'dashboard/RECEIVE_ADJUSTER_INVOICES_FAILURE';

export const CLEAR_ADJUSTER_DASHBOARD = 'dashboard/CLEAR_ADJUSTER_DASHBOARD'; 
export const REQUEST_ADJUSTER_DASHBOARD = 'dashboard/REQUEST_ADJUSTER_DASHBOARD'; 
export const RECEIVE_ADJUSTER_DASHBOARD = 'dashboard/RECEIVE_ADJUSTER_DASHBOARD'; 
export const RECEIVE_ADJUSTER_DASHBOARD_FAILURE = 'dashboard/RECEIVE_ADJUSTER_DASHBOARD_FAILURE';

export const REQUEST_ADMIN_DASHBOARD = 'dashboard/REQUEST_ADMIN_DASHBOARD'; 
export const RECEIVE_ADMIN_DASHBOARD = 'dashboards/RECEIVE_ADMIN_DASHBOARD'; 
export const RECEIVE_ADMIN_DASHBOARD_FAILURE = 'dashboard/RECEIVE_ADMIN_DASHBOARD_FAILURE';

export const REQUEST_MONTHLY_CLAIM_ACTIVITY = 'dashbaord/REQUEST_MONTHLY_CLAIM_ACTIVITY'; 
export const RECEIVE_MONTHLY_CLAIM_ACTIVITY = 'dashbaord/RECEIVE_MONTHLY_CLAIM_ACTIVITY'; 

export const REQUEST_PAYROLL_DASHBOARD = 'payroll/REQUEST_PAYROLL_DASHBOARD'; 
export const RECEIVE_PAYROLL_DASHBOARD = 'payroll/RECEIVE_PAYROLL_DASHBOARD'; 
export const RECEIVE_PAYROLL_DASHBOARD_FAILURE = 'payroll/RECEIVE_PAYROLL_DASHBOARD_FAILURE';